import { type ReactNode } from 'react'


export default function PageLayout({ children, tabbarPage = false, isHeader = true }: { children: ReactNode, tabbarPage?: boolean, isHeader?: boolean }) {
    return (
        <div className={`page-transition ${isHeader ? 'pt-14' : 'pt-0'} ${tabbarPage ? 'pb-17' : ''}`}>
            {children}
        </div>
    )
}